import { render, staticRenderFns } from "./MsgCenter.vue?vue&type=template&id=233fe6b3&"
import script from "./MsgCenter.vue?vue&type=script&lang=js&"
export * from "./MsgCenter.vue?vue&type=script&lang=js&"
import style0 from "./MsgCenter.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports